import { useEffect, useState } from "react";

import { useSnackbar } from "notistack";
import { useGetTipoDocumentoQuery, useGetTipoDocumentosQuery } from "../tipoDocumento/tipoDocumentoApiSlice";
import { TipoDocumento } from "../../types/tipoDocumento/TipoDocumento";


type Props = {
    inputValue: string;
    handleSetLoad: (newValue: boolean) => void;
};




const useTipoDocumentoFetch = (
    {
        inputValue,
        handleSetLoad
    }: Props) => {


    const [options, setOptions] = useState<TipoDocumento[]>([]);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();



    if (handleSetLoad) { handleSetLoad(true); }

    const { data, isFetching, error } = useGetTipoDocumentosQuery(inputValue);

    useEffect(() => {

        if (data) {
            setOptions(data);
        }

        if (error) {
            let msgBox: string = ""
            if ('status' in error) {
                if (error.status == 'FETCH_ERROR') {
                    msgBox += 'Erro de conexão ao solicitar o serviço! Verifique sua internet. FETCH_ERROR '
                } else {
                    msgBox += 'Erro ao buscar os dados:  ' + (error.status)
                }
            } else {
                msgBox += 'Erro encontrado:' + error
            }
            enqueueSnackbar(msgBox, { variant: "error" });
        }

    }, [isFetching, error])

    if (handleSetLoad) { handleSetLoad(false); }

    return { options };
};


export default useTipoDocumentoFetch;